import { useLoadingPhrase } from "./useLoadingPhrase";

interface TimelineSpinnerProps {
  /** Plain text for screen readers, and on screen until a phrase arrives. */
  label: string;
  /** Fill the window. Otherwise cover the stage it sits in. */
  page?: boolean;
  /** Rotate this book's funny phrases over the label. */
  phrasesBookId?: string;
  /** The chapter being opened, when the URL names one. */
  chapterId?: string;
}

export function TimelineSpinner({
  label,
  page = false,
  phrasesBookId,
  chapterId,
}: TimelineSpinnerProps) {
  const phrase = useLoadingPhrase(phrasesBookId, chapterId);
  return (
    <div
      className={`timeline-spinner${page ? " timeline-spinner--page" : ""}`}
      role="status"
      aria-label={label}
    >
      <span className="timeline-spinner__ring" aria-hidden="true" />
      <span className="timeline-spinner__label" aria-hidden="true">{phrase ?? label}</span>
    </div>
  );
}
